import { Component, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApiService } from '../services/api.service';
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { ReportComponent } from '../components/report/report.component';
import { SchemeWiseRoutePopupComponent } from '../components/scheme-wise-route-popup/scheme-wise-route-popup.component';
import { Tooltip } from 'chart.js';
@Component({
  selector: 'app-higher-authority',
  imports: [TableModule, FormsModule, CommonModule, DialogModule, ReactiveFormsModule, ToastModule, RadioButtonModule, DropdownModule, ReportComponent, SchemeWiseRoutePopupComponent],
  templateUrl: './higher-authority.component.html',
  providers: [MessageService],
})
export class HigherAuthorityComponent implements OnInit {
  displayDialogN: boolean = false;
  isApproveDialogVisible=false
  proposalData: any[] = [];
  selectedProposals=[]
  baseUrl: string = environment.APIUrl;
  constructor(private apiService: ApiService, private messageService: MessageService, private router: Router) {}


  ngOnInit(): void {
    this.apiCall();
  }

  apiCall(){
    this.apiService.getAPI('/transaction/user-activity/proposal/').subscribe((res:any)=>{
      this.proposalData = res;
    })
  }

  getStatusBadgeClass(status: string): string {
    const normalized = (status || '').toLowerCase();

    // Light pastel pill badge — closely matches the screenshot style
    if (normalized === 'initiated')
      return 'bg-green-100 text-green-700 rounded px-2 py-1 text-xs font-semibold border border-green-200';
    if (normalized === 'unqualified')
      return 'bg-red-100 text-red-600 rounded px-2 py-1 text-xs font-semibold border border-red-200';
    if (normalized === 'proposal')
      return 'bg-blue-100 text-blue-700 rounded px-2 py-1 text-xs font-semibold border border-blue-200';
    if (normalized === 'new')
      return 'bg-blue-100 text-blue-700 rounded px-2 py-1 text-xs font-semibold border border-blue-200';
    if (normalized === 'renewal')
      return 'bg-blue-100 text-blue-700 rounded px-2 py-1 text-xs font-semibold border border-blue-200';
    
    // fallback
    return 'bg-gray-100 text-gray-700 rounded px-2 py-1 text-xs font-semibold border border-gray-200';
  }
  isRemarkDialogVisible=false
  type:number=0
  remarkText:string=''
  onApprove(event: any) {
    let payload = this.selectedProposals.map((proposal: any) => {
      let route:any;
      if(this.type === 2 ){
        route = {
          remark: event.internalComment,
          is_external: event.shareType === 'external',
          editor_turn: proposal.editor_turn_id,
          is_final_editor:false,
          step_status: 'rejected',
        };
        if (event.shareType === 'external') {
          route.unit_id = event.selectedUnit?.id;
          route.command = event.selectedCommand;
        } else {
          route.user = event.selectedUser?.id;
        }
      }else{
        route={
          editor_turn: proposal.editor_turn_id,
        }
      }
      return route;
    });

    this.apiService.postAPI('/transaction/user-activity/proposal/', payload).subscribe((res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Proposal submitted successfully.' });
      this.isRemarkDialogVisible = false;
      this.apiCall();
    });
  }
  submitRemark(type:number){
    if(type === 2)
    {
      this.showConfirm = true;
      this.getUserList()
      this.getUnits();
      return;
    }
    this.type = type;
    this.isRemarkDialogVisible = true;
  }
  
 
  

  apiResponse:any;
  getApiResponse(rowData:any): void {
    let url = '';
    if([4,5,9,51,50].includes(rowData.scheme_id)) {
      url = `/idex/proposal/report/${rowData?.proposal_id}/`;
    } else if(rowData.scheme_id === 1) {
      url = `/revenue/proposal/report/${rowData?.proposal_id}/`;
    } else if([6,12,14].includes(rowData.scheme_id)) {
      url = `/make1/proposal/report/${rowData?.proposal_id}/`;
    } else if(rowData.scheme_id === 16) {
      url = `/tdf/proposal/report/${rowData?.proposal_id}/`;
    }

    this.apiService.getAPI(url).subscribe((res:any)=>{
      this.apiResponse = res;
      this.isApproveDialogVisible = true;
    });
    this.getDocumentList(rowData);
  }

  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((o, key) => (o && o[key] !== undefined) ? o[key] : '', obj);
  }
  documentList: any[] = [];
    getDocumentList(rowData:any): void {
    if (!rowData?.proposal_id) return;
    this.documentList = [];
    this.apiService.getAPI(`/transaction/dms/files/?proposal_step__proposal=${rowData?.proposal_id}`).subscribe((res:any)=>{
      this.documentList = res?.data || [];
    });
  }

  getProposalSteps(notif:any){


  // Example: Navigate based on notif type
   if ([7,5,4,9,50,51].includes(notif.scheme_id)) {
      this.router.navigate(['/idex-aditi-transaction'], {
        queryParams: { id: notif.proposal_id, name: notif.proposal_name, scheme: notif.scheme_id, step:notif.proposal_step_id }
      });
    } else if (notif.scheme_name == 'Make I') {
      this.router.navigate(['/make-i-transaction'], {
       queryParams: { id: notif.proposal_id, name: notif.proposal_name, scheme: notif.scheme_id, step:notif.proposal_step_id }
      });
    } else if (notif.scheme_name == 'Make II') {
      this.router.navigate(['/make-ii-transaction'], {
       queryParams: { id: notif.proposal_id, name: notif.proposal_name, scheme: notif.scheme_id, step:notif.proposal_step_id }
      });
    } else if (notif.scheme_name == 'Make III') {
      this.router.navigate(['/make-ii-transaction'], {
       queryParams: { id: notif.proposal_id, name: notif.proposal_name, scheme: notif.scheme_id, step:notif.proposal_step_id }
      });
    } else if (notif.scheme_name == 'TDF') {
      this.router.navigate(['/tdf-transaction'], {
      //  queryParams: { id: notif.proposal_id, name: notif.proposal_name, scheme: notif.scheme_id, step:notif.proposal_step_id }
      queryParams: { id: notif.proposal_id, name: notif.proposal_name, scheme: notif.scheme_id, step:notif.proposal_step_id }
      });
    }
    else {
      this.router.navigate(['/transaction'], {
       queryParams: { id: notif.proposal_id, name: notif.proposal_name, scheme: notif.scheme_id, step:notif.proposal_step_id }
      });
    }
  }


  showConfirm:boolean=false;
  userList: any[] = [];
  selectedUser: any;
  actionType: string = '';
  selectedCategory:string = '';
  shareType: string | null = null;
  selectedUnit: any;
  unitList:any[]=[]
  acceptSelectedProposals(){
    
  }
  getUnits() {
    this.apiService.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
    });
  }
  getUserList() {
    const unit = parseInt(sessionStorage.getItem('unit_id') || '0');
    this.apiService.getAPI(`/account/users/?unit=${unit}`).subscribe((res: any) => {
      this.userList = res.data;
    });
  }

  openDialog(type:number) {
    this.type = type;
    this.displayDialogN = false;
    setTimeout(() => (this.displayDialogN = true),100);
  }
  
}
